var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.165,0,38.324-17.148,38.344-38.307 v-76.451H0V385.379z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "353.102,211.862 353.102,194.207 335.447,194.207 335.447,150.069 344.275,150.069  344.275,132.414 291.309,132.414 291.309,150.069 300.137,150.069 300.137,194.207 273.654,194.207 273.654,132.414  282.482,132.414 282.482,114.759 229.516,114.759 229.516,132.414 238.344,132.414 238.344,194.207 211.861,194.207  211.861,150.069 220.689,150.069 220.689,132.414 167.723,132.414 167.723,150.069 176.551,150.069 176.551,194.207  158.895,194.207 158.895,211.862 167.723,211.862 167.723,282.483 158.895,282.483 158.895,300.138 353.102,300.138  353.102,282.483 344.275,282.483 344.275,211.862  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M273.654,291.31h-35.31V256c0-9.751,7.904-17.655,17.655-17.655l0,0 c9.751,0,17.655,7.904,17.655,17.655V291.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M255.999,167.724c-4.875,0-8.828,3.953-8.828,8.828v26.483h17.655v-26.483 C264.826,171.676,260.874,167.724,255.999,167.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M317.792,176.552c-4.875,0-8.828,3.953-8.828,8.828v17.655h17.655V185.38 C326.62,180.503,322.667,176.552,317.792,176.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M194.206,176.552c-4.875,0-8.828,3.953-8.828,8.828v17.655h17.655V185.38 C203.033,180.503,199.081,176.552,194.206,176.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M326.62,291.31h-35.31v-26.483c0-9.751,7.904-17.655,17.655-17.655l0,0 c9.751,0,17.655,7.904,17.655,17.655V291.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M220.689,291.31h-35.31v-26.483c0-9.751,7.904-17.655,17.655-17.655l0,0 c9.751,0,17.655,7.904,17.655,17.655V291.31z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M280.275,322.207c0-1.474-0.737-2.854-1.965-3.672l-17.897-11.932v-3.737l15.215-7.608 c2.182-1.09,3.064-3.742,1.974-5.922c-1.095-2.185-3.737-3.064-5.922-1.974l-15.681,7.84l-15.681-7.84 c-2.173-1.09-4.832-0.211-5.922,1.974c-1.09,2.181-0.207,4.832,1.974,5.922l15.215,7.608v3.737l-17.897,11.932 c-1.228,0.819-1.965,2.198-1.965,3.672s0.737,2.854,1.965,3.672l17.897,11.932v37.362H233.93v6.759c0,2.44,1.974,4.414,4.414,4.414 c1.689,0,3.159-0.948,3.901-2.345h9.341v8.828h-9.418c-0.762-1.319-2.189-2.207-3.823-2.207c-2.44,0-4.414,1.974-4.414,4.414v6.621 h17.655v4.414c0,2.44,1.974,4.414,4.414,4.414s4.414-1.974,4.414-4.414v-4.414v-26.483v-37.362l17.897-11.932 C279.538,325.06,280.275,323.681,280.275,322.207z M255.999,330.142l-11.905-7.935l11.905-7.935l11.905,7.935L255.999,330.142z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/gi.0e2750d8f84a11df236388c35ba7464f.svg";
export { ForwardRef as ReactComponent };